import { Component, inject } from '@angular/core';
import { MillSectorTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MillSectorTypeCreateDto,
  MillSectorTypeDto,
  MillSectorTypeExcelDownloadDto,
  MillSectorTypeUpdateDto,
} from '../proxy/planning/dtos/mill-sector-type';
import { MILLSECTORTYPE_CONFIG, MILLSECTORTYPE_FIELDS } from './mill-sector-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-mill-sector-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MillSectorTypeService, ConfirmationService],
  templateUrl: './mill-sector-type.html',
  styleUrl: './mill-sector-type.scss',
})
export class MillSectorType extends BaseCrudComponent<
  MillSectorTypeDto,
  MillSectorTypeCreateDto,
  MillSectorTypeUpdateDto,
  MillSectorTypeExcelDownloadDto
> {
  service = inject(MillSectorTypeService);
  config = MILLSECTORTYPE_CONFIG;
  fields = MILLSECTORTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: MillSectorTypeDto): MillSectorTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MillSectorType';
  }
}
